import { Schema, SchemaGetter } from "effect";

/**
 * v3 `Schema.clamp`, which v4 removed: decoding moves an out-of-range number into
 * `[minimum, maximum]` instead of rejecting it, and encoding passes the value through.
 */
export const clamp =
  (minimum: number, maximum: number) =>
  <S extends Schema.Top & { readonly Type: number }>(self: S) =>
    self.pipe(
      Schema.decode<S>({
        decode: SchemaGetter.transform((n: number) => Math.min(maximum, Math.max(minimum, n))),
        encode: SchemaGetter.passthrough(),
      })
    );
